import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      {/* breadcrumb start */}
      <div
        className="cta4-section-area mkt150 bg-[#243A5E]"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="cta-content-area heading1">
                <h2 className="text-anime-style-3">Privacy Policy</h2>
                <div className="space16" />
                <p>Your Privacy, Our Priority</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* breadcrumb end */}

      <div className="w-full h4-pricing-wrapper pb-[60px] md:pb-[6rem] max-md:pt-[60px] max-md:px-[20px] md:pt-[100px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="md:px-[100px]">
                    <p>
                    Kavatch Healthcare (“Kavatch Healthcare”, “we”, “us”, or “our”) respects
                      the privacy of our users (“you” or “your”). This Privacy
                      Policy describes how we collect, use, disclose, and
                      protect your personal information when you access and use
                      our website (the “Website”) and our SaaS-based healthtech
                      infrastructure (the “Service”).
                    </p>
                    <p>
                      <strong>1. Information We Collect</strong>
                    </p>
                    <p>
                      We collect several types of information from and about you
                      when you use the Website and Service:
                    </p>
                    <div>
                      <p>
                        <strong>Personal Information:</strong> This includes
                        information that can be used to identify you directly,
                        such as your name, email address, phone number, and
                        postal address. We may collect this information when you
                        create an account, contact us, or use certain features
                        of the Service.
                      </p>
                      <p>
                        <strong>Usage Data:</strong> We collect information
                        about your activity on the Website and Service, such as
                        the pages you visit, the features you use, and the time
                        you spend on the Website and Service.
                      </p>
                      <p>
                      <strong>Device Information:</strong> We collect information
                        about the device you use to access the Website and Service,
                        such as your device type, operating system, browser type, IP
                        address, and device identifiers.
                        </p>
                        <p>
                          <strong> Health &amp; Fitness Data:</strong> Our app accesses
                          and collects the following health and fitness data through
                          Android Health Connect (Google Health Connect):
                        </p>
                        <div style={{ paddingLeft: 10 }}>
                          <p>
                            <strong>Step Count:</strong> We access your daily step count
                            to display your physical activity progress within the app.
                          </p>
                          <p>
                            <strong>How we use this data:</strong> To display your daily
                            step count and progress toward your personal fitness goal
                            within the app interface.
                          </p>
                          <p>
                            <strong>Data Storage:</strong> Step count data is processed
                            locally on your device and is not transmitted to our servers
                            or stored externally.
                          </p>
                          <p>
                            <strong>Data Sharing:</strong> We do not sell, share, or
                            transfer your health or fitness data to any third parties.
                          </p>
                          <p>
                            <strong>Your Control:</strong> You can revoke Health Connect
                            permissions at any time via{" "}
                            <strong>
                              Android Settings → Health Connect → App permissions →
                              Kavatch Healthcare
                            </strong>
                            .
                          </p>
                    </div>
                    </div>
                    <p>
                      <strong>2. How We Use Your Information</strong>
                    </p>
                    <p>We use your information to:</p>
                    <div style={{ paddingLeft: 10 }}>
                      <p>- Provide and operate the Website and Service</p>
                      <p>- Process your requests and transactions</p>
                      <p>
                        - Send you important information about the Website and
                        Service, including updates, security alerts, and support
                        messages
                      </p>
                      <p>
                        - Communicate with you about your use of the Website and
                        Service
                      </p>
                      <p>- Monitor and improve the Website and Service</p>
                      <p>
                        - personalize your experience on the Website and Service
                      </p>
                      <p>- Comply with legal and regulatory requirements</p>
                    </div>
                    <p>
                      <strong>3. Disclosure of Your Information</strong>
                    </p>
                    <p>
                      We may disclose your information to third-party service
                      providers who help us operate the Website and Service.
                      These service providers are obligated to protect your
                      information and are only permitted to use it for the
                      purposes we instruct them.
                    </p>
                    <p>
                      We may also disclose your information if we are required
                      to do so by law or in the good faith belief that such
                      disclosure is necessary to:
                    </p>
                    <div style={{ paddingLeft: 10 }}>
                      <p>Comply with a legal process</p>
                      <p>
                        Protect the rights or safety of you, Kavatch Healthcare, or
                        others
                      </p>
                    </div>
                    <p>
                      <strong>4. Data Retention</strong>
                    </p>
                    <p>
                      We will retain your information for as long as your
                      account is active or as needed to provide you with the
                      Website and Service. We may also retain your information
                      for legal, regulatory, and audit purposes.
                    </p>
                    <p>
                      <strong>5. Your Choices</strong>
                    </p>
                    <p>You have certain choices regarding your information:</p>
                    <div style={{ paddingLeft: 10 }}>
                      <p>
                        You can access and update your personal information
                        through your account settings.
                      </p>
                      <p>
                        You can unsubscribe from our marketing communications by
                        following the unsubscribe instructions in those
                        communications.
                      </p>
                    </div>
                    <p>
                      <strong>6. Security</strong>
                    </p>
                    <p>
                      We take reasonable steps to protect your information from
                      unauthorized access, disclosure, alteration, or
                      destruction. However, no internet transmission or
                      electronic storage is 100% secure.
                    </p>
                    <p>
                      <strong>7. Children’s Privacy</strong>
                    </p>
                    <p>
                      The Website and Service are not directed to children under
                      the age of 18. We do not knowingly collect personal
                      information from children under 18. If you are a parent or
                      guardian and you believe your child has provided us with
                      personal information, please contact us.
                    </p>
                    <p>
                      <strong>8. International Transfers</strong>
                    </p>
                    <p>
                      Your information may be transferred to and processed in
                      countries other than your own. These countries may have
                      different data protection laws than your own country.
                    </p>
                    <p>
                      <strong>9. Changes to this Privacy Policy</strong>
                    </p>
                    <p>
                      We may update this Privacy Policy from time to time. We
                      will post the updated Privacy Policy on the Website. You
                      are advised to review this Privacy Policy periodically for
                      any changes.
                    </p>
                    <p>
                        <strong>10. Data Deletion</strong>
                      </p>
                      <p>
                        Users have the right to request deletion of their
                        personal data.
                      </p>
                      <p className="pl-2">
                        a. You can request data deletion by: contacting us at:{" "}
                        <p className="font-semibold inline">
                          support@kavatchhealthcare.com
                        </p>
                      </p>
                      <p className="pl-2">b. Once we receive your request:</p>
                      <p className="pl-4">
                        i. We will delete your data within 7–30 days
                      </p>
                      <p className="pl-4">
                        ii. Some data may be retained if required by law or for
                        legitimate business purposes
                      </p>
                    <p>
                      <strong>11. Contact Us</strong>
                    </p>
                    <p>
                      If you have any questions about this Privacy Policy,
                      please contact us at <p className="font-semibold inline">
                          support@kavatchhealthcare.com
                        </p>.
                    </p>
                  </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
